import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import { t } from '../../../auto/js/services';
import { STATUS_SIGNED } from '../../../auto/js/metadata/Status';
import { loadingIcon } from '../../../auto/js/loadingIcon';

const statusColor = {
  "SIGNED": 'success'
};

const RequestCard = ({ request, action }) => (
  <Card variant="outlined" sx={{
    width: '100%',
    borderRadius: 2, // equivalent to 16px
    }} >
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        #REQ-{request.id}
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h6" gutterBottom>
            {request.title}
        </Typography>
        {(request.status === STATUS_SIGNED) ? (
                <Chip
                clickable
                onClick={() => action(request)}
                label={request.status}
                color={statusColor[request.status]}
                size="small"
                sx={{
                    height: 36, // typical Button height
                    fontSize: '0.875rem', // similar to Button text
                    px: 2, // horizontal padding to match button feel
                    borderRadius: '6px', // optional: to match button roundness
                  }}
                />
            ) : (
                <Button variant="contained" size="small" onClick={() => action(request)} sx={{ mt: 1 }}>
                {t`View`}
                </Button>
            )}
      </Box>
        <>
        <Stack direction="row" spacing={0.5}>
            <DescriptionIcon fontSize="small" />
            <Typography variant="body2">{request.documents} documents</Typography>
        </Stack>
          
        </>
      
    </CardContent>
  </Card>
);

export default function IncommingSignature(props) {
  const [incomingRequests, setIncomingRequests] = useState(undefined);

  if (!incomingRequests) {
    props.loadData().then((data) => {
      setIncomingRequests(data)
    })
    return loadingIcon;
  }

  return (
    <Container maxWidth={false} style={{position: 'relative', top: '61px'}}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: ['column', 'column', 'row'],
          gap: 4,
        }}
      >
        {/* Incoming Signature Requests */}
        <Box sx={{ flex: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" gutterBottom>
                {t`Incoming Signature Requests`}
                </Typography>
                <Button className="link-button" onClick={() => props.seeAll()}>
                    {t`See all`}
                </Button>
            </Box>
          <Stack spacing={2}>
            {incomingRequests.map((req) => (
              <RequestCard key={req.id} request={req} action={props.action}/>
            ))}
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}
